var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcHome20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.496 15.92c0 .875.744 1.58 1.667 1.58h4.168v-5.529c0-.437.372-.79.834-.79h1.667c.462 0 .834.353.834.79V17.5h4.168c.923 0 1.667-.705 1.667-1.58V8.812H2.496v7.108Z",
  fill: "#7DBEFF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.501 8.022c.539 0 .936-.48.808-.978l-1.481-3.949c-.09-.352-.423-.595-.808-.595H3.99c-.385 0-.718.25-.808.595 0 0-1.103 2.777-1.481 3.95-.16.491.269.977.808.977H17.5Z",
  fill: "#2D91FF"
})));
export default SvgIcHome20X20;